module.exports = __webpack_public_path__ + "img/color_en.a8f1a2b.jpg";